import { useTranslation } from 'react-i18next';
import { Card, Divider, Flex, Grid, Loader, Text, Title } from '@mantine/core';
import moment from 'moment';
import { BarChart } from '@mantine/charts';
import { useMemo } from 'react';
import { useGetProductStatisticsReport } from '../../../hooks/reports/queries';
import momentTz from 'moment-timezone';
import { CommonReportChartProps, graphColors } from '.';

const TopTenProductsChart = ({ dateRange, chartHeight }: CommonReportChartProps) => {
  const { t } = useTranslation(['ReportsPage', 'FieldName', 'CommonButtons', 'Notifications']);
  const searchParams = new URLSearchParams(location.search);
  const searchParamStoreId = searchParams.get('storeId') || '';
  const { data, isLoading } = useGetProductStatisticsReport(searchParamStoreId, {
    fromDate: dateRange[0]?.toISOString(),
    toDate: dateRange[1]?.toISOString(),
    timezone: momentTz.tz.guess(true)
  });

  const chartData = useMemo(() => {
    return (
      data?.productsReport.map((productData) => {
        const randomColor = graphColors[Math.floor(Math.random() * graphColors.length)].hex;
        return {
          ...productData,
          color: randomColor
        };
      }) || []
    );
  }, [data]);
  return (
    <Card h="100%">
      <Card.Section inheritPadding withBorder py="md">
        <Grid>
          <Grid.Col span={12}>
            <Title>{t('ReportsPage:topTenProductsReport.title')}</Title>
            <Text c={'dimmed'}>
              {moment(dateRange[0]).format('DD MMMM YYYY')} -{' '}
              {moment(dateRange[1]).format('DD MMMM YYYY')}
            </Text>
          </Grid.Col>
          {isLoading && <Loader m={'auto'} />}
          {!isLoading && (
            <>
              <Grid.Col>
                <BarChart
                  h={chartHeight}
                  data={chartData}
                  dataKey="name"
                  series={[{ name: 'quantity', label: t('FieldName:quantity') }]}
                  tickLine="y"
                />
              </Grid.Col>
              <Grid.Col span={12}>
                {data?.productsReport &&
                  data.productsReport.map((product) => {
                    return (
                      <>
                        <Divider size="sm" my="xs" />
                        <Flex justify="space-between" align="center">
                          <Text>{product.name}</Text>
                          <Text>{product.quantity}</Text>
                        </Flex>
                      </>
                    );
                  })}
                {!data?.productsReport?.length && (
                  <Text ta={'center'}>{t('ReportsPage:noData')}</Text>
                )}
              </Grid.Col>
            </>
          )}
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default TopTenProductsChart;
